module.exports = __webpack_public_path__ + "static/gmail-9dbc79dab48422c821c75bbfc21165ec.svg";